import { Link } from "react-router-dom";

export function ResponsibleGamingPage() {
  return (
    <section className="page legal-page">
      <h1>Responsible gaming</h1>
      <p className="muted">
        Predabet is for entertainment and research. If you choose to gamble
        elsewhere, do so responsibly and within the law.
      </p>

      <h2>Disclaimer</h2>
      <p>
        <strong>DISCLAIMER:</strong> This site is 100% for entertainment
        purposes only and does not involve real money betting or prizes.
      </p>
      <p>
        Sports betting is regulated and permitted only in select U.S. states.
        This content is intended solely for individuals of legal betting age
        (often <strong>21+</strong>). Availability varies by location.{" "}
        <strong>No guarantees of outcomes are made.</strong> Please check your
        local laws and gamble responsibly.
      </p>

      <h2>Age guidance</h2>
      <ul>
        <li>
          <strong>18+</strong> to use Predabet.
        </li>
        <li>
          <strong>21+</strong> is a common minimum age for regulated sports
          betting in the U.S. (varies by jurisdiction).
        </li>
      </ul>

      <h2>Need help?</h2>
      <p>
        If you or someone you know may have a gambling problem, call{" "}
        <strong>1-800-GAMBLER (1-800-426-2537)</strong>.
      </p>

      <h2>Tips</h2>
      <ul>
        <li>
          <strong>Set a budget</strong> and don’t chase losses.
        </li>
        <li>
          <strong>Take breaks</strong> and keep betting as entertainment, not
          income.
        </li>
        <li>
          <strong>Don’t bet</strong> when stressed, upset, or impaired.
        </li>
      </ul>

      <p className="muted small" style={{ marginTop: "1rem" }}>
        Back to <Link to="/">Predictions</Link>. See also{" "}
        <Link to="/terms">Terms</Link> and <Link to="/privacy">Privacy</Link>.
      </p>
    </section>
  );
}
